module.exports = __webpack_public_path__ + "static/media/scale.abf4ec23.svg";